import {useState} from "react";

function Register() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [passwordConfirm, setPasswordConfirm] = useState('');

    const [submit, setSubmit] = useState(false);
    const [errorNullInputs, setErrorNullInputs] = useState(false);
    const [errorPasswordMismatch, setErrorPasswordMismatch] = useState(false);
    const [errorPasswordLength, setErrorPasswordLength] = useState(false);

    const handleUsername = (e) => {
        setUsername(e.target.value);
    }
    const handlePassword = (e) => {
        setPassword(e.target.value);
    }
    const handlePasswordConfirm = (e) => {
        setPasswordConfirm(e.target.value);
    }

    const handleRegistration = () => {
        // assign api to a value
        let api = 'https://iot-temphumid.herokuapp.com/register';
        // create a new object
        let newUser = {
            username: username,
            password: password
        }
        // fetch the api
        fetch(api, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(newUser)
        })
            .then(res => res.json())
            .then(data => {
                console.log(data);
            })
            .catch(err => console.log(err));
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        //check if fields are empty
        // set all error states to false
        setErrorNullInputs(false);
        setErrorPasswordMismatch(false);
        setErrorPasswordLength(false);
        setSubmit(false);

        if (username === '' || password === '' || passwordConfirm === '') {
            setErrorNullInputs(true);
        } else if (password.length < 8) {
            setErrorPasswordLength(true);
        }
         else if (password !== passwordConfirm) {
            setErrorPasswordMismatch(true);
        } else {
            setSubmit(true);
            handleRegistration();
        }
    }

    const successMessage = () => {
        //copy username to a new variable
        let usernameCopy = username;
        return (
            <div className="success" style={{
                display: submit ? 'block' : 'none',
            }}>
                <h1>Success!</h1>
                <p>You have successfully registered {usernameCopy}!</p>
            </div>
        )
    }

    const errorMessage = () => {
        return (
            <div className="error" style={{
                display: errorNullInputs ? 'block' : 'none',
            }}>
                <h1>Error!</h1>
                <p>Please enter all fields</p>
            </div>
        )
    }

    const errorMessagePasswordMismatch = () => {
        return (
            <div className="error" style={{
                display: errorPasswordMismatch ? 'block' : 'none',
            }}>
                <h1>Error!</h1>
                <p>Passwords do not match!</p>
            </div>
        )
    }

    const errorMessagePasswordLength = () => {
        return (
            <div className="error" style={{
                display: errorPasswordLength ? 'block' : 'none',
            }}>
                <h1>Error!</h1>
                <p>Password must be at least 8 characters long!</p>
            </div>
        )
    }
    return (
        <div className="container mt-5">
            <div className="row">
                <div className="col-md-6 mx-auto">
                    <div className="messages">
                        {successMessage()}
                        {errorMessagePasswordLength()}
                        {errorMessage()}
                        {errorMessagePasswordMismatch()}
                    </div>
                    <div className="card">
                        <div className="card-header">
                            <h4>Register</h4>
                        </div>
                        <div className="card-body">
                            <form>
                                <div className="form-group">
                                    <label for="username">Username</label>
                                    <input onChange={handleUsername} type="text" className="form-control" id="username" placeholder="Enter username" value={username} />
                                </div>
                                <div className="form-group">
                                    <label for="password">Password</label>
                                    <input onChange={handlePassword} type="password" className="form-control" id="password" placeholder="Enter password" value={password} />
                                </div>
                                <div className="form-group">
                                    <label for="confirmPassword">Confirm Password</label>
                                    <input onChange={handlePasswordConfirm} type="password" className="form-control" id="confirmPassword" placeholder="Confirm password" value={passwordConfirm} />
                                </div>
                                <button onClick={handleSubmit} type="submit" className="btn btn-primary btn-block mt-2">Submit</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Register;